import { Injectable } from '@angular/core';
import { ApiService } from 'merlin-library';
import { ClinicianApiEndPointConstants } from 'projects/clinician/src/app/utilitites/api-end-point-constants';
import { of } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class TermsConditionsService {
    constructor(private apiService: ApiService) {}

    setUserConsent(userRecordId, payload) {
        return this.apiService.put(ClinicianApiEndPointConstants.updateUserTerms(userRecordId), payload);
    }
}
